import React from 'react'
import { Button } from '@/components/ui/button'
import { Volume2, VolumeX, Home } from 'lucide-react'
import Spinner from '@/components/ui/spinner'
import RequestEditModal from './bnt-requestEdit'
import { UserType } from '@/types/user'
import { ClientType } from '@/types/client'
import { EditSuggestion } from './SuggestionsPanel'
import { ROUTE_BUILDERS } from '@/config/routes'

interface ToolbarProps {
  isSpeaking: boolean
  handleSpeak(): void
  handleStop(): void
  agreementData?: any
  displaySignatureButton: boolean
  displaySignatureIsVerifedButton: boolean
  canCloseContract: boolean
  shouldContinueWitnessFlow: boolean

  isSignatureLoading: boolean
  isFetching: boolean
  handleClient(): void
  handleUpdateAgreement(): void
  selectedIcon: string
  id: string
  fullStyledHtml: string
  generatePDF(html: string, logo: string, id: string): void
  user?: UserType | null
  client?: ClientType | null
  historySuggestions?: EditSuggestion[]
  handleBack(): void
  nextWitnessSlot: number
}

export const MinutaToolbar: React.FC<ToolbarProps> = ({
  isSpeaking,
  handleSpeak,
  handleStop,
  agreementData,
  displaySignatureButton,
  displaySignatureIsVerifedButton,
  canCloseContract,
  shouldContinueWitnessFlow,
  isSignatureLoading,
  isFetching,
  handleClient,
  handleUpdateAgreement,
  selectedIcon,
  id,
  fullStyledHtml,
  generatePDF,
  user,
  client,
  handleBack,
  nextWitnessSlot
}) => {
  return (
    <div className="w-full text-center mb-6">
      <h1 className="text-3xl md:text-3xl font-bold mb-6 text-gray-800">Contrato</h1>
      <div className="flex flex-wrap justify-center gap-2 md:gap-4">
        <Button onClick={isSpeaking ? handleStop : handleSpeak}>
          {isSpeaking ? <VolumeX className="mr-2 h-4 w-4" /> : <Volume2 className="mr-2 h-4 w-4" />}
          {isSpeaking ? 'Parar' : 'Ler em voz alta'}
        </Button>

        {displaySignatureButton && !client && (
          <Button onClick={handleClient} disabled={isSignatureLoading || isFetching}>
            Login Cliente {(isSignatureLoading || isFetching) && <Spinner />}
          </Button>
        )}

        {displaySignatureButton && client && (
          <Button onClick={handleClient} disabled={isSignatureLoading || isFetching}>
            Registrar Assinatura {(isSignatureLoading || isFetching) && <Spinner />}
          </Button>
        )}

        {canCloseContract && <Button onClick={handleUpdateAgreement}>Fechar Contrato</Button>}

        {shouldContinueWitnessFlow && <Button onClick={handleClient}>Continuar fechamento</Button>}

        {!displaySignatureButton &&
          agreementData?.isTermoWitness &&
          !agreementData?.witnessesComplete &&
          id && (
            <Button onClick={() => (window.location.href = ROUTE_BUILDERS.signWitness(id, nextWitnessSlot))}>
              Assinar testemunha {nextWitnessSlot}
            </Button>
          )}

        {!displaySignatureIsVerifedButton &&
          !canCloseContract &&
          agreementData?.status === `ANALISE_CONCLUIDA` &&
          !agreementData?.isFrist && <Button onClick={handleUpdateAgreement}>Fechar Contrato</Button>}

        {/* {!displaySignatureButton && <UserAssinaturaButtonTesteClient id_client={id} />} */}

        <Button onClick={() => generatePDF(fullStyledHtml, selectedIcon, id)}>Baixar PDF</Button>

        {(user || client) && agreementData?.id && !agreementData?.isAssinado && (
          <div className="flex justify-end">
            <RequestEditModal idAgreement={agreementData.id} />
          </div>
        )}

        {(user || client) && (
          <Button onClick={handleBack} title="Voltar" className="fixed bottom-4 left-4 rounded-full w-12 h-12">
            <Home className="w-6 h-6" />
          </Button>
        )}
      </div>
    </div>
  )
}
